module.exports = __webpack_public_path__ + "img/natural-ingredients--xxl.3546e3a5.jpg";